import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpEvent, HttpResponse } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { KeycloakService } from './keycloak.service';

export type KeycloakHttpObserve = 'body' | 'response' | 'events';

export interface KeycloakHttpRequestOptions {
  headers?: HttpHeaders | { [header: string]: string | string[] };
  params?: HttpParams | { [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean> };
  observe?: KeycloakHttpObserve;
  responseType?: 'json' | 'text' | 'blob' | 'arraybuffer';
  withCredentials?: boolean;
  reportProgress?: boolean;
  body?: any;
}

@Injectable()
export class KeycloakHttpService {
  constructor(
    private http: HttpClient) {}

  request<T>(urlOrMethod: string, urlOrOptions?: string | KeycloakHttpRequestOptions, maybeOptions?: KeycloakHttpRequestOptions): Observable<any> {
    let method = 'GET';
    let url: string;
    let options: KeycloakHttpRequestOptions = {};

    if (typeof urlOrOptions === 'string') {
      method = urlOrMethod;
      url = urlOrOptions;
      options = maybeOptions ?? {};
    } else {
      url = urlOrMethod;
      options = (urlOrOptions ?? {}) as KeycloakHttpRequestOptions;
    }

    return this.http.request(method, url, options as any);
  }
}

export function keycloakHttpFactory(http: HttpClient): KeycloakHttpService {
  return new KeycloakHttpService(http);
}
